import { Portfolio } from '@amzn/awscat-portfolio-assessment-types';
import { createContext, FC, useState } from 'react';


export interface IPortfolioContext {
    portfolio: Portfolio,
    updatePortfolio: (portfolio: Portfolio) => void;
}

const dummyPortfolio: Portfolio = {
    accountName: 'accountName',
    customerAccountId: 'customerAccountId',
    assessmentId: '',
    createdAt: new Date(),
    createdBy: '',
    dataUpdated: new Date(),
    id: 'dummyPortfolio',
    isTestPortfolio: true,
    name: 'Empty Portfolio',
    refId: '',
    updatedAt: new Date(),
    updatedBy: '',
};

export const PortfolioContext = createContext<IPortfolioContext>({
    portfolio: dummyPortfolio,
    updatePortfolio: () => {},
});

export const PortfolioProvider: FC = ({ children }) => {
    const [ portfolio, setPortfolio ] = useState<Portfolio>(dummyPortfolio);

    const updatePortfolio = (updatedPortfolio: Portfolio) => {
        setPortfolio(updatedPortfolio);
    };

    return (
        <PortfolioContext.Provider
            value={{
                portfolio,
                updatePortfolio,
            }}
        >
            {children}
        </PortfolioContext.Provider>
    );
};
